import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { getModalLocation } from '../../../lib/modal'
import NavLinkWithQuery from '../../../components/shared/nav-link-with-query'
import Button from '../../../components/button'
import styles from './login-nav-button.css'

function LoginNavButton({
  location,
  searchIsClicked
}) {
  return (
    <>
      <NavLinkWithQuery
        exact
        to={getModalLocation(location, 'login')}
        analyticsLabel="login"
        className={classNames(styles.navLink, searchIsClicked && styles.navLinkWhileSearching)}
      >
        <Button
          text="log in"
          wrapperClassName={styles.linkButtonFrame}
          className={styles.linkButton}
          e2eIdentifier="nav-login"
          darkBGSecondary
        />
      </NavLinkWithQuery>
    </>
  )
}

LoginNavButton.propTypes = {
  searchIsClicked: PropTypes.bool.isRequired
}

export default LoginNavButton
